import { render, staticRenderFns } from "./multi-choice-response.vue?vue&type=template&id=75b397e6&scoped=true&"
import script from "./multi-choice-response.vue?vue&type=script&lang=js&"
export * from "./multi-choice-response.vue?vue&type=script&lang=js&"
import style0 from "./multi-choice-response.vue?vue&type=style&index=0&id=75b397e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b397e6",
  null
  
)

component.options.__file = "multi-choice-response.vue"
export default component.exports